import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const api = {
  // auth
  createSession: (sessionId) =>
    client.post("/auth/session", {}, { headers: { "X-Session-ID": sessionId } }),
  me: () => client.get("/auth/me"),
  logout: () => client.post("/auth/logout"),
  // config / usage
  config: () => client.get("/config"),
  usage: () => client.get("/usage"),
  summary: (month) => client.get("/dashboard/summary", { params: month ? { month } : {} }),
  // receipts
  scanReceipt: (formData) =>
    client.post("/receipts/scan", formData, { headers: { "Content-Type": "multipart/form-data" } }),
  listReceipts: () => client.get("/receipts"),
  createReceipt: (data) => client.post("/receipts", data),
  updateReceipt: (id, data) => client.patch(`/receipts/${id}`, data),
  deleteReceipt: (id) => client.delete(`/receipts/${id}`),
  // subscriptions
  listSubscriptions: () => client.get("/subscriptions"),
  createSubscription: (data) => client.post("/subscriptions", data),
  updateSubscription: (id, data) => client.patch(`/subscriptions/${id}`, data),
  deleteSubscription: (id) => client.delete(`/subscriptions/${id}`),
  // admin
  adminUsers: () => client.get("/admin/users"),
  adminSetPremium: (email, is_premium) => client.post("/admin/set-premium", { email, is_premium }),
  // google play billing (server-side verification; the only path to Premium)
  billingConfig: () => client.get("/billing/google/config"),
  verifyGooglePurchase: (purchase_token, product_id) =>
    client.post("/billing/google/verify", { purchase_token, product_id }),
  restoreGooglePurchases: (purchases) =>
    client.post("/billing/google/restore", { purchases }),
  // export
  exportCsvUrl: () => `${API}/export/receipts.csv`,
};

export default client;
